export default "__VITE_ASSET__911687b1__"